import React, { FC } from 'react';
import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import styles from './BloodPressureComponent.module.scss';
import boddVariables from '../../../variables.module.scss';
import BloodPressureIcon from '../../../assets/bloodpressure.svg';
import { WellnessItem } from '../../../services/DataFormatService';

interface BloodPressureComponentProps {
    systolicBPItem: WellnessItem,
    diastolicBPItem: WellnessItem,
}

const BloodPressureComponent: FC<BloodPressureComponentProps> = (props) => {
    const { systolicBPItem, diastolicBPItem } = props;
    return (
        <Box
            className={styles.BloodPressureComponent}
            data-testid="BloodPressureComponent"
            sx={{
                bgcolor: boddVariables.white,
                border: 2,
                borderColor: '#EBE9E1',
                borderRadius: 1.75,
                py: '21px',
                mt: 3,
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-evenly">
                <SvgIcon sx={{ width: 41, height: 41 }}><BloodPressureIcon /></SvgIcon>
                <Stack alignItems="flex-start">
                    <Typography sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '16px',
                        lineHeight: '24px',
                        color: boddVariables.black,
                    }}
                    >
                        Blood pressure (standing)
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '24px',
                        lineHeight: '38px',
                        color: boddVariables.black,
                    }}
                    >
                        {systolicBPItem!.formattedValue}
                        /
                        {diastolicBPItem!.formattedValue}
                        {' '}
                        mmHg
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BloodPressureComponent;
